import { commonFunctions } from "../_utilities/commonFunctions";
import { configs } from "../config";
import { configes } from "../webData";

export const homeService = {
  getMakesByTenantId, 
  getCarsByTenantId,
  getBrandsByTenantId,
  carInquiry,
  partExchnageInquiry,
  sendEmail,
  testDrive,
  getTopBannerDetail,
  getAboutBannerDetail,
  getAbouthistoryBannerDetail,
  getCarDetail,
};


function getMakesByTenantId() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getMakes/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function getCarsByTenantId() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getCars/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function getBrandsByTenantId() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getBrands/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function carInquiry(data) {
  const extraHeaders = {
    "Content-Type": "application/json",
  };
  const requestOptions = commonFunctions.getRequestOptions(
    "POST",
    extraHeaders,
    JSON.stringify(data)
  );
  return fetch(
    `${configs.localApiUrl}/createCarInquirie?tenantId=${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function partExchnageInquiry(data) {
  const extraHeaders = {
    "Content-Type": "application/json",
  };
  const requestOptions = commonFunctions.getRequestOptions(
    "POST",
    extraHeaders,
    JSON.stringify(data)
  );
  return fetch(
    `${configs.localApiUrl}/createPartExchangeInquirie?tenantId=${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function sendEmail(data) {
  const extraHeaders = {
    "Content-Type": "application/json",
  };

  const requestOptions = commonFunctions.getRequestOptions(
    "POST",
    extraHeaders,
    JSON.stringify(data)
  );
  return fetch(
    `${configs.localApiUrl}/sendEmail?tenantId=${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function testDrive(data) {
  const extraHeaders = {
    "Content-Type": "application/json",
  };
  const requestOptions = commonFunctions.getRequestOptions(
    "POST",
    extraHeaders,
    JSON.stringify(data)
  );
  return fetch(
    `${configs.localApiUrl}/testDrive?tenantId=${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function getTopBannerDetail() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getTopBannerDetail/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function getAboutBannerDetail() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getAboutBannerDetail/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}

function getAbouthistoryBannerDetail() {
  const requestOptions = commonFunctions.getRequestOptions("GET");
  return fetch(
    `${configs.localApiUrl}/getAboutHistoryBannerDetail/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}
function getCarDetail(data) {
  const extraHeaders = {
    "Content-Type": "application/json",
  };

  const requestOptions = commonFunctions.getRequestOptions(
    "POST",
    extraHeaders,
    JSON.stringify(data)
  );
  return fetch(
    `${configs.localApiUrl}/getCarsBySlug/${configes.domainId}`,
    requestOptions
  ).then((response) => response.json());
}
